export default "__VITE_ASSET__bff19382__"